import React from 'react';
import { Container, Row, Card, Col } from 'react-bootstrap';

const Services = () => {
    return (
        <div>
            <Container>
                <h1>Services</h1>
            Service: The company is built on strong foundations of professionalism; technical integrity and diversified professional products. The package of professional products on offer are summarised as follows:

            Source products and get quotations

            Inspect factories and samples

            Eye of China

            Follow up  after-sales

            Visa, flight,  hotel,transport translation, etc
            <Row>
               <Col >
                <img style={{width: '100%'}} src="/assets/images/infographic.jpg" />
                </Col>
            </Row>
           

            </Container>
        </div>
    );
};

export default Services;